<template>
  <vx-card
    class="h-full hive-list__hive_card"
    :class="userRole === 'tenant_master' && hive.user.id !== userInfo.user_id ? '' : 'hive-list__hive_card-hover cursor-pointer'"
    @click="goChartData(hive)"
  >
    <div slot="no-body" class="h-full">
      <div class="p-4">
        <div class="flex items-center mb-3">
          <div class="hive_card_hive_name mb-0 text-warning text-truncate mr-3">{{ hive.name }}</div>
          <div class="hive-list__hive_card_header_info ml-auto">
            <div class="text-right flex">
              <div class="mr-1" v-if="hive.alarm==true">
                <hexasense-icon :w="30" :h="28"  :icon="'bell-badge-icon'" :text="1" />
              </div>
              <div class="mr-1" v-if="hive.signal">
                <hexasense-icon :w="28" :h="26"  :icon="'signal-alt-1-icon'" v-if="hive.signal >= 0 && hive.signal <= 7" />
                <hexasense-icon :w="28" :h="26"  :icon="'signal-alt-2-icon'" v-else-if="hive.signal >= 8 && hive.signal <= 15" />
                <hexasense-icon :w="28" :h="26"  :icon="'signal-alt-3-icon'" v-else-if="hive.signal >= 16 && hive.signal <= 23" />
                <hexasense-icon :w="28" :h="26"  :icon="'signal-alt-4-icon'" v-else-if="hive.signal >= 24 && hive.signal <= 31" />
              </div>
              <div v-if="hive.battery">
                <hexasense-icon :w="28" :h="26"  :icon="'battery-quarter-icon'" v-if="hive.battery>=3" />
                <hexasense-icon :w="28" :h="26"  :icon="'battery-icon'" v-else />
              </div>
            </div>
          </div>
        </div>
        <div class="mb-5">
          <div class="h6 text-muted text-truncate mb-1">{{ hive.apiary }}</div>
          <div
            class="h6 text-muted text-truncate"
             v-if="userRole !== 'user'"
          >
            {{ hive.user.company ? hive.user.company : "" }}
            {{ hive.user.company && hive.user.first_name ? "-" : "" }}
            {{
              hive.user.first_name
                ? hive.user.first_name + " " + hive.user.last_name
                : ""
            }}
          </div>
        </div>
        <div class="font-size-13">
          <div class="mb-2">
            <div >{{ $t("hives.Bee") }}</div>
            <div class="font-bold text-truncate">
              {{ hive.bee_type ? hive.bee_type.name : "--" }}
            </div>
          </div>
          <div class="">
            <div>{{ $t("hives.detail.HiveType") }}</div>
            <div class="font-bold text-truncate">
              {{ hive.hive_type ? hive.hive_type.name : "--" }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-between text-center">
        <div
          class="w-1/2
            border border-solid
            d-theme-border-grey-light
            border-r-0 border-b-0 border-l-0
          "
        >
          <p class="mt-4">{{ $t("hives.detail.Temperature") }}</p>
          <p class="mb-4 text-xl font-semibold">
            {{ hive.temp ? hive.temp : "--" }}°C
          </p>
        </div>
        <div
          class="w-1/2
            border border-solid
            d-theme-border-grey-light
            border-r-0 border-b-0
          "
        >
          <p class="mt-4">{{ $t("hives.detail.Humidity") }}</p>
          <p class="mb-4 text-xl font-semibold">
            {{ hive.hum ? hive.hum : "--" }}%
          </p>
        </div>
      </div>

      <div class="hive-list__hive_card_footer p-4">
        <div class="flex justify-start">
          <span class="flex items-center">
            <small class="mr-1 text-muted"
              >{{ $t("apiaries.LastUpdate") }}:</small
            >
            <small class="text-muted">{{
              hive.timestampms ? hive.timestampms : "--"
            }}</small>
          </span>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import HexasenseIcon from '../../../libs/icons/index.vue'
export default {
  components:{HexasenseIcon},
  props: {
    hive: {
      type: Object,
      require: true
    }
  },
  computed: {
    userRole () {
      return this.$store.getters.userRole
    },
    userInfo () {
      return this.$store.getters.returnUserInfo
    }
  },
  methods: {
    goChartData (hive) {
      if (this.userRole === 'tenant_master') {
        if (hive.user.id === this.userInfo.user_id) {
          this.$router.push(`/hives/hive/${hive.id}`)
        }
      } else {
        this.$router.push(`/hives/hive/${hive.id}`)
      }
    }
  }
}
</script>

<style lang="scss">
.hive-list__hive_card {
  .vx-card__collapsible-content {
    height: 100% !important;
  }
  .hive-list__hive_card_footer {
    border-top: 1px solid #dae1e7;
  }
  .hive_card_hive_name{
    font-size: 18px;
    font-family: inherit;
    font-weight: 500;
  }
}

.hive-list__hive_card-hover:hover {
  margin-top: -5px;
  margin-bottom: 5px;
}
</style>
